// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      sponsorBusinessProcessOptions: [
        "Operations",
        "Maintenance",
        "Engineering",
        "Management",
        "Project"
      ],
      // eslint-disable-next-line
      ownerBusinessProcessOptions: [
        "Site",
        "Contractor",
        "Consultant",
        "Vendor",
        "Operations",
        "Maintenance",
        "Engineering",
        "Management",
        "Project",
        "Regulator"
      ],
      // eslint-disable-next-line
      independentOwnerOptions: [
        "Any",
        "Team",
        "Unit",
        "Facility",
        "Company"
      ]
    };
  }
};
